import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PageActionsContextType {
  pageActions: ReactNode;
  setPageActions: (actions: ReactNode) => void;
}

const PageActionsContext = createContext<PageActionsContextType>({
  pageActions: null,
  setPageActions: () => {},
});

export const PageActionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [pageActions, setPageActions] = useState<ReactNode>(null);

  return (
    <PageActionsContext.Provider value={{ pageActions, setPageActions }}>
      {children}
    </PageActionsContext.Provider>
  );
};

export const usePageActions = () => useContext(PageActionsContext);

export default PageActionsContext;
